import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const settingsWrapperCss = "sf2l50h";
export const SettingsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(settingsWrapperCss, props.className)} />;
});
const settingsModalWrapperCss = "s4gk6wf";
export const SettingsModalWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(settingsModalWrapperCss, props.className)} />;
});
const deleteDisclaimerWrapperIsPhoneCss = "d9whs7n";
const deleteDisclaimerWrapperCss = "d1xoic3h";
export const DeleteDisclaimerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(deleteDisclaimerWrapperCss, {
    [deleteDisclaimerWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const modifiedPageContainerIsTabletUpCss = "memzlgm";
const modifiedPageContainerIsPhoneCss = "mlgv9xw";
const modifiedPageContainerCss = "m4gwig5";
export const ModifiedPageContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(modifiedPageContainerCss, {
    [modifiedPageContainerIsTabletUpCss]: isTabletUp,
    [modifiedPageContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const disclaimerButtonCss = "d1ilithx";
export const DisclaimerButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(disclaimerButtonCss, props.className)} />);
const disclaimerButtonWrapperIsPhoneCss = "d1m46t60";
const disclaimerButtonWrapperCss = "d1g5o8e5";
export const DisclaimerButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(disclaimerButtonWrapperCss, {
    [disclaimerButtonWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");